import React from "react";
import { styles } from "../../Form";
import {
  CssTextFieldSignIn,
  CssButtonSignIn,
  CssTextFieldPhone,
  CssTextFieldPhoneCode,
  CssLoginTitleTypography,
  CssLink,
} from "../../styles/styled";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import { MenuItem } from "@mui/material";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: "center",
  color: theme.palette.text.secondary,
  boxShadow: "none",
}));

function SignUp({ updateFormState, updateFormType, signUp, errMess }) {
  let errorLabel = "";
  if (errMess !== "") {
    errorLabel = <label style={styles.errorLabel}>{errMess}</label>;
  }
  return (
    <div style={styles.signUpContainer}>
      <Box
        style={{
          backgroundColor: "#26890d",
          position: "absolute",
          width: "480px",
          top: 0,
          height: "40px",
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
        }}
      >
        <CssLoginTitleTypography>新規登録</CssLoginTitleTypography>
      </Box>
      <Box style={{ height: "40px" }}></Box>
      <label style={styles.label}>メールアドレス</label>
      <CssTextFieldSignIn
        id="signinEmail"
        defaultValue=""
        size="small"
        name="email"
        onChange={(e) => {
          e.persist();
          updateFormState(e);
        }}
      />
      <label style={styles.label}>パスワード</label>
      <CssTextFieldSignIn
        id="signInPassword"
        defaultValue=""
        size="small"
        type="password"
        name="password"
        onChange={(e) => {
          e.persist();
          updateFormState(e);
        }}
      />
      <label style={styles.label}>電話番号</label>
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={2}
      >
        <Item>
          <CssTextFieldPhoneCode
            disabled={true}
            id="signUpPhoneCode"
            defaultValue={"japan"}
            value={"japan"}
            size="small"
            name="phone_code"
          >
            <MenuItem value={"japan"}>+81</MenuItem>
          </CssTextFieldPhoneCode>
        </Item>
        <Item>
          <CssTextFieldPhone
            id="signUpPhoneNumber"
            defaultValue=""
            size="small"
            name="phone_number"
            onChange={(e) => {
              e.persist();
              updateFormState(e);
            }}
          />
        </Item>
      </Stack>
      {errorLabel}
      <CssButtonSignIn
        variant="contained"
        size="large"
        color="success"
        onClick={signUp}
      >
        新規登録
      </CssButtonSignIn>
      <p style={styles.toggleForm}>
        既にアカウントをお持ちですか。{" "}
        <CssLink
          component="button"
          variant="body2"
          onClick={() => updateFormType("signIn")}
        >
          ログイン
        </CssLink>
      </p>
    </div>
  );
}

export default SignUp;
